import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Column, Icon, Phrase, Row, Spacer } from "@neru/ui";
import { classNames } from "@neru/utils";
import DOMPurify from "dompurify";
import { Link } from "react-router-dom";
import { useNotifications } from "../../hooks";
import { Browser, URL } from "../../utils";
export var DetailCard = function(param) {
    var accent = param.accent, _param_copy = param.copy, copy = _param_copy === void 0 ? false : _param_copy, tmp = param["data-testid"], testId = tmp === void 0 ? "detail-card" : tmp, icon = param.icon, title = param.title, url = param.url, value = param.value;
    var showSuccess = useNotifications().showSuccess;
    var copyData = function() {
        if (value) {
            Browser.copyToClipboard(value);
            showSuccess(value, {
                header: "Copied!"
            });
        }
    };
    var viewValue = value ? /*#__PURE__*/ _jsx("span", {
        dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(value)
        }
    }) : null;
    if (url) {
        if (URL.isAbsoluteURL(url)) {
            viewValue = /*#__PURE__*/ _jsx("a", {
                "data-testid": "link-".concat(title),
                href: url,
                children: value
            });
        } else {
            viewValue = /*#__PURE__*/ _jsx(Link, {
                "data-testid": "link-".concat(title),
                to: url,
                children: value
            });
        }
    }
    return /*#__PURE__*/ _jsx(Column, {
        className: classNames(!accent && "border-b border-primary-100 py-1", "grow"),
        "data-testid": testId,
        children: /*#__PURE__*/ _jsxs(Row, {
            children: [
                /*#__PURE__*/ _jsxs(Column, {
                    className: "grow",
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            className: "flex-nowrap items-center",
                            children: [
                                icon ? /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Icon, {
                                            size: "small",
                                            type: icon
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            size: "xs"
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ _jsx(Phrase, {
                                    className: "whitespace-nowrap text-sm text-primary-950",
                                    children: title
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Phrase, {
                            className: "text-base font-normal",
                            children: viewValue
                        })
                    ]
                }),
                copy && /*#__PURE__*/ _jsx(Column, {
                    className: "justify-center",
                    children: /*#__PURE__*/ _jsx(Button, {
                        "data-testid": "copy-to-clipboard",
                        icon: "copy-2-line",
                        onClick: copyData,
                        size: "condensed"
                    })
                })
            ]
        })
    });
};

//# sourceMappingURL=DetailCard.js.map